<section
  class="flex h-full w-full flex-col overflow-hidden bg-white"
  role="dialog"
  [attr.aria-label]="'board_v3_stage_settings_title' | translate"
>
  <header class="flex items-center gap-3 border-b border-gray-100 px-5 py-4">
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-lg font-bold text-gray-900">{{ 'board_v3_stage_settings_title' | translate }}</h2>
      <p class="m-0 mt-1 text-sm text-gray-500">{{ 'board_v3_stage_settings_hint' | translate }}</p>
    </div>
  </header>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-5 py-4">
    @if (stageColumns.length) {
      <div
        cdkDropList
        class="flex flex-col gap-2"
        [cdkDropListData]="stageColumns"
        [cdkDropListDisabled]="isSaving"
        (cdkDropListDropped)="onStageDrop($event)"
      >
        @for (column of stageColumns; track column.id) {
          <div cdkDrag class="flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-3 shadow-sm">
            <button type="button" cdkDragHandle class="cursor-grab text-gray-400 active:cursor-grabbing" [attr.aria-label]="'board_v3_reorder_stage' | translate">
              <app-icon>drag_indicator</app-icon>
            </button>
            <span class="h-4 w-4 shrink-0 rounded-full border border-black/10" [style.backgroundColor]="column.color.background"></span>
            <span class="min-w-0 flex-1 truncate font-medium text-gray-800">{{ column.name }}</span>
            @if (isSystemColumn(column)) {
              <span class="rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-600">
                {{ (column.type === 'SUCCESS' ? 'board_v3_column_type_success' : 'board_v3_column_type_failed') | translate }}
              </span>
            }
            <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-500">{{ column.count_cards }}</span>
            <button
              type="button"
              class="flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
              [attr.aria-label]="'board_v3_edit_stage' | translate"
              [disabled]="isSaving"
              (click)="onEditStage(column)"
            >
              <app-icon>edit</app-icon>
            </button>
            <button
              type="button"
              class="flex h-8 w-8 items-center justify-center rounded-lg text-red-500 hover:bg-red-50 disabled:cursor-not-allowed disabled:text-gray-300 disabled:hover:bg-transparent"
              [attr.aria-label]="'board_v3_delete_stage' | translate"
              [attr.title]="isLastSystemColumn(column) ? ('board_v3_last_system_column_hint' | translate) : null"
              [disabled]="isSaving || isLastSystemColumn(column)"
              (click)="onDeleteStage(column)"
            >
              <app-icon>delete</app-icon>
            </button>
          </div>
        }
      </div>
    } @else {
      <p class="m-0 rounded-xl bg-gray-50 p-4 text-sm text-gray-500">{{ 'board_v3_no_stages' | translate }}</p>
    }
  </div>

  <footer class="flex justify-between gap-3 border-t border-gray-100 px-5 py-4">
    <app-button [btnType]="'stroked'" [disabled]="isSaving" (onChangeClick)="onClose()">
      {{ 'close' | translate }}
    </app-button>
    <app-button [disabled]="isSaving || !funnelId" (onChangeClick)="onAddStage()">
      <span class="flex items-center gap-1"><app-icon>add</app-icon>{{ 'board_v3_add_stage' | translate }}</span>
    </app-button>
  </footer>
</section>
